import React from 'react'
import BgPavet from "../../img/Background-paves.jpg"
import { Link } from 'react-router-dom'

function Garantie() {
  return (
    <div className="relative font-sans before:absolute before:w-full before:h-full before:inset-0 before:bg-gray-800 before:opacity-50 before:z-10">
      <img src={BgPavet} alt="Pavet" className="absolute inset-0 w-full h-full object-cover" />

      <div className="min-h-[350px] relative z-50 h-full max-w-6xl mx-auto flex flex-col justify-center items-center text-center text-white p-6">
        <h2 className="sm:text-4xl text-2xl poppins-bold mb-6">Garantie des produits</h2>
        <p className="sm:text-lg text-base text-center text-gray-200 poppins-regular">
            Nous sommes fiers de la qualité de nos produits et offrons une garantie d'un an pour assurer votre satisfaction et tranquillité d'esprit.
        </p>

        <Link
          to="/produits"
          className="mt-12 bg-transparent text-white poppins-semibold text-base py-3 px-6 border-2 border-pink-600 rounded-lg hover:bg-pink-600 transition-all duration-300">
          Acheter maintenant
        </Link>
      </div>
    </div>
  )
}

export default Garantie